package com.evoapps.evoshift.data.dto.finance

import kotlinx.serialization.Serializable

@Serializable
data class RosterFinancialsDto(
    val rosterId: String,
    val planned: FinancialSummaryDto? = null,
    val actual: FinancialSummaryDto? = null,
    val combined: FinancialSummaryDto? = null,
    val days: Int = 0,
    val daysWithTakings: Int = 0
)

@Serializable
data class FinancialSummaryDto(
    val laborCost: Double = 0.0,
    val otherCosts: Double = 0.0,
    val revenue: Double = 0.0,
    val laborPercentage: Double = 0.0,
    val commission: Double = 0.0,
    val fixedRevenue: Double = 0.0,
    val otherRevenue: Double = 0.0,
    /** SH-95: "INCOME" or "SALES"; absent before SH-95. */
    val laborBase: String? = null,
    /** SH-95: what the labour % of income is measured against; absent before SH-95. */
    val laborIncome: Double? = null,
    /** SH-95: labour cost ÷ [laborIncome] × 100 (the app computes it from the two; kept for other readers). */
    val laborPercentageOfIncome: Double? = null,
    /** The owner's income from the sales: commission, or net sales without one; absent in older totals. */
    val salesIncome: Double? = null
)
